<template>
  <v-layout
    align-space-around
    justify-center
    column
    fill-height
    id="listing"
    v-scroll:#content="onScroll"
  >
    <router-view></router-view>

    <!-- <v-btn class="mx-2" fab fixed bottom right dark color="secondary" v-show="offset_top > 100" v-scroll:#adverts="onScroll">
	      <v-icon dark>fa-chevron-up</v-icon>
    </v-btn>-->

    <!-- 
	    $vuetify.breakpoint.smAndDown
	    $vuetify.breakpoint.xsOnly 
    -->

    <v-navigation-drawer
      id="map-drawer"
      v-model="show_map"
      v-bind="drawer_props"
      right
      :key="'map'"
    >
      <google-map
        ref="map"
        :options="map_options"
        :markers="item_markers"
        :active_marker="hover_item"
        :active_cluster="hover_cluster"
        @clickMarker="onClickMarker"
        @closeMarker="onCloseMarker"
        @clickCluster="onClickCluster"
        @change="onMapChanged"
        @routeToItem="viewItem"
      ></google-map>
    </v-navigation-drawer>

    <v-fab-transition>
      <v-btn
        v-if="this.$vuetify.breakpoint.xsOnly"
        @click="toggleMap"
        color="primary"
        fab
        dark
        bottom
        right
        fixed
        style="z-index:101"
      >
        <v-icon>mdi-map</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      @click="toTop"
      color="primary"
      fab
      dark
      small
      bottom
      left
      fixed
      class="to-top-fab"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
    <v-flex xs12 style>
      <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="black"></v-progress-linear>
      <v-card tile color="transparent" flat>
        <v-overlay :absolute="true" :value="loading" color="white" :opacity="0.2"></v-overlay>

        <v-data-iterator
          :items="items"
          :page="currrent_page"
          :items-per-page="per_page"
          :loading="loading"
          @pagination="onPaginate"
          ref="iterator"
          hide-default-footer
          :footer-props="{
            showFirstLastPage: true,
            disableItemsPerPage: false,
          }"
        >
          <template v-slot:header>
            <advert-filter @update="onUpdateFilters"></advert-filter>
          </template>
          <template v-slot:no-results>
            <v-alert class="py-5 my-5 text-center" elevation="0">
              <p>No Results Found</p>
            </v-alert>
          </template>
          <template v-slot:default="props">
            <v-container fluid>
              <v-container fluid>
                <!-- <v-layout wrap>
								<v-flex v-for="item in props.items" :key="item.uuid" xs12 sm6 class="pa-2">
									<advert-item v-bind="item" @click.self="viewItem">
										<v-btn text color="primary" @click.stop="viewItem">{{ trans('app.show_details') }}</v-btn>
									</advert-item>
								</v-flex>
                </v-layout>-->
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    lg="6"
                    xl="4"
                    v-for="item in props.items"
                    :key="item.uuid"
                  >
                    <advert-item
                      @mouseover="onmouseover(item.uuid, item.prefix)"
                      @mouseout="onmouseout(item.uuid, item.prefix)"
                      v-bind="item"
                      @click.self="viewItem"
                    >
                      <v-btn text color="primary" @click.stop="viewItem(item.uuid)">
                        {{
                        trans('app.show_details')
                        }}
                      </v-btn>
                    </advert-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-container>
          </template>

          <template v-slot:loading>
            <div class="text-center py-5 my-5">
              <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
            </div>
          </template>

          <template v-slot:no-data>
            <v-alert class="py-5 my-5" elevation="0">
              <p class="text-center">{{ trans('advert.no_data_adverts') }}</p>
            </v-alert>
          </template>
          <template v-slot:footer="{ pagination }">
            <v-pagination
              v-model="currrent_page"
              :length="Math.round(pagination.itemsLength / pagination.itemsPerPage)"
              :disabled="loading"
              :page="pagination.page"
              circle
            ></v-pagination>
          </template>
        </v-data-iterator>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions, mapState } from "vuex";
import AdvertItem from "../components/AdvertItem";
import GoogleMap from "../google/Map";
import AdvertFilter from "../components/AdvertFilter";
import {
  COUNTRY_CODE,
  COUNTRY_BOUNDS,
  MAP_CENTER,
  DEFAULT_LOCATION,
} from "@/config";

export default {
  components: {
    "google-map": GoogleMap,
    "advert-item": AdvertItem,
    "advert-filter": AdvertFilter,
  },
  data: () => ({
    show_map: true,
    watch_map: true,
    currrent_page: 1,
    per_page: 12,
    fab: false,
    map_options: {
      zoom: 5,
      center: MAP_CENTER,
      zoomControl: true,
      mapTypeControl: true,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUi: false,
      restriction: {
        latLngBounds: COUNTRY_BOUNDS,
        strictBounds: false,
      },
    },
    map: null,
    offset_top: 0,

    debug: "",
    rectangle: null,

    // bugfix
    first_call: false,

    hover_item: null,
    hover_cluster: null,
  }),

  computed: {
    ...mapState("search", {
      // loading: 'loading',
      query: "query",
      pagination: "pagination",
    }),
    ...mapGetters("search", {
      isLoading: "isLoading",
      paginated_items: "paginated_items",
      items: "items",
      clustersStore: "clusters",
      // records: 'items',
      // pagination: 'pagination',
    }),

    loading: function () {
      return this.isLoading("fetch");
    },

    // items: function() {
    //   // return _.filter(this.records, function(o) { return o.count == 1; })
    //   return _.filter(
    //     _.get(this.pagination, "data", []),
    //     e => e.is_cluster != true
    //   );
    // },

    clusters: function () {
      // return _.filter(this.records, function(o) { return o.count > 1; })
      return _.filter(
        _.get(this.pagination, "data", []),
        (e) => e.is_cluster == true
      );
    },

    item_markers: function () {
      let records = this.clustersStore;
      return _.map(records, (e) => {
        return e;
      });
    },

    drawer_props: function () {
      let width = this.$vuetify.breakpoint.xsOnly ? "90%" : "50%";
      let floating = !this.$vuetify.breakpoint.xsOnly;
      let temporary = this.$vuetify.breakpoint.xsOnly;

      let misc = {
        permanent: !this.$vuetify.breakpoint.xsOnly,
        clipped: true,
        app: true,
        overflow: true,
        stateless: true,
      };

      return { ...misc, floating, width, temporary };
    },
  },

  methods: {
    ...mapActions("search", {
      fetch: "fetch",
      setQuery: "setQuery",
      setQueryParam: "setQueryParam",
      loadItems: "loadItems",
    }),

    onPaginate: function (pagi) {
      //console.log(pagi);
      this.$vuetify.goTo(0);
    },

    onUpdateFilters: function (param) {
      this.$google.then((google) => {
        if (_.has(param, "location")) {
          let location = _.get(param, "location");
          let { lat, lng, north, south, west, east } = location;

          this.map.once();
          this.map.fitBounds({ north, south, west, east });
          this.map.setCenter({ lat, lng });

          // debug
          // this.map.drawRect({ north, south, west, east });
        }

        this.setQueryParam(param);
        this.fetch();
      });
    },

    onClickMarker: function (item) {
      this.map.once();
      this.$refs.iterator.search = item.uuid;
    },

    onmouseover: function (uuid, quadkey) {
      if (this.map.active_popup) {
        console.log("prevent");

        return;
      }
      this.hover_item = uuid;
      this.hover_cluster = quadkey;
    },

    onmouseout: function (uuid) {
      this.hover_item = null;
      this.hover_cluster = null;
    },

    onCloseMarker: function () {
      this.$refs.iterator.search = null;
    },

    onClickCluster: function (item) {
      let zoom = this.map.getZoom();
      this.map.once();
      this.map.setZoom(zoom + 1);
      this.map.setCenter({ lat: item.lat, lng: item.lng });
      let location = {
        ...this.map.getBounds().toJSON(),
        ...this.map.getCenter().toJSON(),
        zoom: this.map.getZoom(),
        formatted_address: this.trans(
          "advert.address_placeholder",
          null,
          "Somewhere in USA"
        ),
        place_id: null,
      };
      this.onMapChanged(location);
    },

    onMapChanged: function (location) {
      let { lat, lng, north, south, west, east } = location;
      location.formatted_address =
        north + "," + west + " - " + south + "," + east;

      this.setQueryParam({ location: location });
      this.fetch();

      this.$vuetify.goTo(0);
    },

    viewItem: function (uuid) {
      return this.$router.push({
        name: "advert-details",
        params: { uuid: uuid },
      });
    },

    toggleMap: function () {
      if (this.$vuetify.breakpoint.xsOnly) {
        this.show_map = !this.show_map;
      } else {
        this.show_map = true;
      }
    },
    onScroll(e) {
      const {
        scrollTop,
        clientHeight,
        scrollHeight,
      } = e.target.scrollingElement;
      if (typeof window === "undefined") return;

      const top = window.pageYOffset || scrollTop || 0;
      this.fab = top > 20;

      // if (scrollTop + clientHeight >= scrollHeight) {
      //   this.loadItems();
      // }
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    routeToItem(uuid) {},
  },

  mounted: function () {
    let self = this;
    this.$store.subscribe(({ type, payload }, state) => {
      // Fix the "Lodz bug"
      // The first search always centering the map with issue.
      if (type == "search/handleLoadingStatus") {
        if (
          payload.action == "fetch" &&
          payload.status == true &&
          this.first_call == false
        ) {
          let location = this.query.location;
          let { north, south, west, east } = location;
          if (this.map) {
            this.map.once();
            this.map.fitBounds({ north, south, west, east });
          }

          this.first_call = true;
        }
      }
    });

    this.$google.then((google) => {
      this.map = this.$refs.map;

      if (_.has(this.query, "location")) {
        let location = this.query.location;
        let { lat, lng, north, south, west, east } = location;
        this.map.once();
        this.map.fitBounds({ north, south, west, east });
      } else {
        this.setQueryParam({
          location: DEFAULT_LOCATION,
          available_from: !this.query["available_from"]
            ? new Date().toISOString().split("T")[0]
            : this.query["available_from"],
          property_type: null,
        });
      }

      this.fetch();
    });
  },
};
</script>

<style lang="scss">
.to-top-fab {
  z-index: 101;
  left: 45% !important;
}
@media (max-width: 560px) {
  .to-top-fab {
    z-index: 101;
    left: 20px !important;
  }
}
</style>
